import { render, staticRenderFns } from "./sepa-validation-errors-modal.vue?vue&type=template&id=331d0d7a&scoped=true&"
import script from "./sepa-validation-errors-modal.vue?vue&type=script&lang=js&"
export * from "./sepa-validation-errors-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331d0d7a",
  null
  
)

export default component.exports